module.exports = __webpack_public_path__ + "static/media/piano.eed2c26b.svg";